import PosthogService from '~/services/posthog/PosthogService';

export interface IShiftRequestAutoconfirmEligibleSelectedPayload {
  autoConfirm: 'on' | 'off';
  designDate: number;
}

/**
 * Fires when a user turns autoconfirm eligible professionals ON/OFF on the shift request form
 * Event: dental_portal:shift_request:autoconfirm_eligible_selected
 */
export function fireShiftRequestAutoconfirmEligibleSelected(
  payload: IShiftRequestAutoconfirmEligibleSelectedPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:shift_request:autoconfirm_eligible_selected',
    {
      'auto-confirm': payload.autoConfirm,
      design_date: payload.designDate,
    },
  );
}
